import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink href="https://goo.gl/maps/s3irW85nPwV9WMtMA">
              <CFImage src={mobileMap} w="100%" alt="JL Sushi & Kitchen Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink href="https://goo.gl/maps/s3irW85nPwV9WMtMA">
              <CFImage
                src={locationMap}
                w="100%"
                alt="JL Sushi & Kitchen Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
